import React, { ReactNode } from 'react';

import { useTranslation } from 'react-i18next';

import styles from './bellAlertCountHeader.module.scss';

interface BellAlertCountHeaderProps {
  children: ReactNode;
}

const BellAlertCountHeader = ({ children }: BellAlertCountHeaderProps) => {
  const { t } = useTranslation(['common']);

  return (
    (<div className={styles.header} data-palette="BellAlertCountHeader">
      <div className={styles.notifyCountBox}>
        <span className={styles.notifyText}>{t('common:bellAlerts.notifications')}</span>
      </div>
      {children}
    </div>)
  );
};
export default BellAlertCountHeader;
